import React from 'react';
// import GenerateReport from '../../Containers/ReportsContainer/GenerateReport';

const GenerateReport = React.lazy(() => import('../../Containers/ReportsContainer/GenerateReport'));


const GenerateReports = () => {
	return (
		<GenerateReport />
	);
}

export default GenerateReports;